import React from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
import WorkWithUs from '../../components/workWithUs';
// import Banner from '../../common/Banner/Banner';

const headerTags = {
    title: 'Trabalhe Conosco - Venha fazer parte da equipe', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta: {
        description: 'Trabalhar na Antena 1 é trabalhar com os melhores e para os maiores. Envie o seu currículo e faça parte da rádio online mais ouvida do Brasil!',
        keywords: 'trabalho, procuro trabalho, busco emprego, trabalhe conosco',
        'og:title': 'Trabalhe Conosco - Venha fazer parte da equipe',
        'og:description': 'Trabalhar na Antena 1 é trabalhar com os melhores e para os maiores. Envie o seu currículo e faça parte da rádio online mais ouvida do Brasil!',
    },
};

// Banners
// const programsBannerConfig = {
//     title: 'PUBLICIDADE',
//     class: 'col-11',
//     adUnit: 'a1nova-workWithUs-multi_sizes',
//     sizes: [[970, 250], [970, 90], [728, 90], [336, 280], [320, 50], [300, 250], [300, 100], [250, 250], [234, 60]],
//     sizeMapping: [
//         { viewport: [1250, 0], sizes: [[970, 250], [970, 90], [728, 90]] },
//         { viewport: [991, 0], sizes: [[728, 90], [336, 280], [300, 250], [300, 100]] },
//         { viewport: [365, 0], sizes: [[336, 280], [320, 50], [300, 250], [300, 100]] },
//         { viewport: [0, 0], sizes: [[250, 250], [234, 60]] },
//     ],
//     shouldRefresh: true,
// };

const TrabalheConosco = () => (
    <div className="pageWrapper tw-container tw-m-auto tw-px-5">
        <HeaderTags
            title={headerTags.title}
            meta={headerTags.meta}
        />
        <WorkWithUs />
        {/* <Banner
            key={programsBannerConfig.adUnit}
            config={programsBannerConfig}
        /> */}
    </div>
);

export default TrabalheConosco;
